module.exports = __webpack_public_path__ + "static/media/outlet_app_icon_new.2952b8f5.svg";